<div class="wrapper">
  <a cf-link class="mt-3 d-block" size="sm" (click)="toggleGuest()" *ngIf="!showGuest">
    {{ "booking.add_guests" | translate }}
  </a>

  <ng-container *ngIf="showGuest">
    <cf-form-field>
      <cf-input-label>
        {{ "booking.add_guests_emails" | translate }}
      </cf-input-label>

      <mat-chip-grid #emailChip aria-label="Enter keywords" [formControl]="emailsControl">
        <mat-chip-row disableRipple *ngFor="let email of emails" (removed)="removeEmail(email)">
          {{ email }}
          <svg matChipRemove cfIcon="close" size="sm" class="tw:text-gray-70"></svg>
        </mat-chip-row>
      </mat-chip-grid>

      <input
        class="order-last"
        cf-input
        [matChipInputSeparatorKeyCodes]="[32, 13, 188]"
        [matChipInputFor]="emailChip"
        (matChipInputTokenEnd)="addEmail($event)"
        [matChipInputAddOnBlur]="true"
        (input)="errorMsg.set(null)"
      />
    </cf-form-field>
    @if (errorMsg(); as error) {
      <cf-input-error [message]="error"> </cf-input-error>
    }
  </ng-container>
</div>
